import React, { useEffect } from "react";
import LandingFooter from "views/Landing/LandingFooter";
import LandingHeader from "views/Landing/LandingHeader";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import routes from "../routes/index";

const LandingLayout = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const history = useHistory();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) =>
    routes
      .filter((r) => r.layout === "public")
      .map((route, key) => (
        <Route key={key} path={route.path} component={route.component} />
      ));

  useEffect(() => {
    if (location.pathname == "/") {
      history.push("/home");
    }
  }, [location]);

  return (
    <div className="landing" ref={mainContent}>
      <LandingHeader />
      <Switch>
        {getRoutes(routes)}
        <Redirect from="*" to="/" />
      </Switch>
      <LandingFooter />
    </div>
  );
};

export default LandingLayout;
